import { render, staticRenderFns } from "./OnboardingContactPrivacy.vue?vue&type=template&id=84471710&"
import script from "./OnboardingContactPrivacy.vue?vue&type=script&lang=js&"
export * from "./OnboardingContactPrivacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports